export default __webpack_public_path__ + "static/media/question_mark.a3e26faa.svg";